const prodConfig = [
  {
    BRAND_CODE: 'anchor',
    VUE_APP_API_HOST: 'https://api.clp.kr/anchor',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/anchor',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyB8MAScWWvu8TtHvmj5aEfYO3LFtu4vEVU',
      authDomain: 'anchor-prod-a11de.firebaseapp.com',
      databaseURL: 'https://anchor-prod-a11de-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'anchor-prod-a11de',
      storageBucket: 'anchor-prod-a11de.firebasestorage.app',
      messagingSenderId: '990059322812',
      appId: '1:990059322812:web:9eaee38efcec2ec2f8dfb9',
      measurementId: 'G-E5DCSFB503',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    NAVER_KEY: 'SG9YzxagYHMO5aBqZx3v',
    TELEGRAM_BOT: 'anchor_prod_bot',
  },
  {
    BRAND_CODE: 'brk',
    VUE_APP_API_HOST: 'https://api.clp.kr/brk',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/brk',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyC39P_AhqOCOXfi7At3CSMYLq48N2MTDvI',
      authDomain: 'brkorea-896a1.firebaseapp.com',
      databaseURL: 'https://brkorea-896a1.firebaseio.com',
      projectId: 'brkorea-896a1',
      storageBucket: 'brkorea-896a1.appspot.com',
      messagingSenderId: '754859726124',
      appId: '1:754859726124:web:bee7b18c6d2783aff30889',
      measurementId: 'G-X9CWZP560P',
    },
    VUE_COMMON_CSS: 'brk',
    NAVER_KEY: '3cOHMcg0vEvdMS_Fhaha',
    TELEGRAM_BOT: 'brk_prod_bot',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'dkk',
    VUE_APP_API_HOST: 'https://api.clp.kr/dkk',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/dkk',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCQJWi-TodOkNrJ44WlY6lO2h8sXiRHQZA',
      authDomain: 'dookki-6eee2.firebaseapp.com',
      databaseURL: 'https://dookki-6eee2-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'dookki-6eee2',
      storageBucket: 'dookki-6eee2.firebasestorage.app',
      messagingSenderId: '1063223003391',
      appId: '1:1063223003391:web:3a60fbc792d495aa7124ca',
      measurementId: 'G-2BR1BZZF2S',
    },
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'drj',
    VUE_APP_API_HOST: 'https://api.clp.kr/drj',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/drj',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyBQrBtgnFXIGuwnw4sH9CIsluykgv-qXSY',
      authDomain: 'drjarton.firebaseapp.com',
      databaseURL: 'https://drjarton.firebaseio.com',
      projectId: 'drjarton',
      storageBucket: 'drjarton.appspot.com',
      messagingSenderId: '377526382509',
      measurementId: 'G-T0XWJJGQ7V',
      appId: '1:377526382509:web:0fd7a178a1e33e9f75fb24',
    },
    VUE_COMMON_CSS: 'drj',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'gck',
    VUE_APP_API_HOST: 'https://api.clp.kr/gck',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/gck',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCF1Cj9nceGzbgfkfw1k8IJF1bKlH9hPMk',
      authDomain: 'gongcha-a551a.firebaseapp.com',
      databaseURL: 'https://gongcha-a551a.firebaseio.com',
      projectId: 'gongcha-a551a',
      storageBucket: 'gongcha-a551a.appspot.com',
      messagingSenderId: '425113607524',
      appId: '1:425113607524:web:c642161efe180524a0ee71',
      measurementId: 'G-EKB7613LY9',
    },
    VUE_COMMON_CSS: 'gck',
    NAVER_KEY: 'Ctoa0lyVsd0rllDj0cw0',
    TELEGRAM_BOT: 'gck_prod_bot',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'sol',
    VUE_APP_API_HOST: 'https://api.clp.kr/sol',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/sol',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyDBddWbyX3COzZzAvv_aswd8hXF7hVh9QQ',
      authDomain: 'solabel-9d4a1.firebaseapp.com',
      databaseURL: 'https://solabel-9d4a1-default-rtdb.firebaseio.com',
      projectId: 'solabel-9d4a1',
      storageBucket: 'solabel-9d4a1.appspot.com',
      messagingSenderId: '345376516608',
      appId: '1:345376516608:web:6b2d40e412fa2066fd86e5',
      measurementId: 'G-J8H863RFSL',
    },
    VUE_COMMON_CSS: 'sol',
    NAVER_KEY: 'JaRc9tKNBwUEQyz5UdV6',
    TELEGRAM_BOT: 'sol_prod_bot',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'anb',
    VUE_APP_API_HOST: 'https://api.clp.kr/anb',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/anb',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCdQIGWkUiyWaNGtadRvVCrBqnEdCEVE0k',
      authDomain: 'tinker-education-f6d5b.firebaseapp.com',
      databaseURL: 'https://tinker-education-f6d5b.firebaseapp.com',
      projectId: 'tinker-education-f6d5b',
      storageBucket: 'tinker-education-f6d5b.appspot.com',
      messagingSenderId: '488048351871',
      appId: '1:488048351871:web:b85a4a77b06a2802ed3d4a',
    },
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: ['anb01'],
    IDP_SERVICE_URL: {
      udemyUrl: 'https://anbschool2.udemy.com',
      githubUrl: 'https://github.com/login?return_to=https://github.com/orgs/anb-hq/repositories',
      judgeUrl: 'https://judge.clp.kr',
      idpUrl: 'https://sp-anb.clp.kr/anb-student-mobile/login',
      reviewBoardUrl: 'http://review.clp.kr/', // NOSONAR config url
    },
    IDP_SIGNOUT_URL: 'https://sp-anb.clp.kr/anb-student-mobile/signout',
  },
  {
    BRAND_CODE: 'btr',
    VUE_APP_API_HOST: 'https://api.clp.kr/btr',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/btr',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyB2rWyK_21_qD2EUGCrdEMpXqukbNMfAPY',
      authDomain: 'beautyrise-8c6cc.firebaseapp.com',
      databaseURL: 'https://beautyrise-8c6cc-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'beautyrise-8c6cc',
      storageBucket: 'beautyrise-8c6cc.appspot.com',
      messagingSenderId: '834688582226',
      appId: '1:834688582226:web:e37357686899b2d92a158b',
      measurementId: 'G-Q5SSN1HD3W',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'hlg',
    VUE_APP_API_HOST: 'https://api.clp.kr/hlg',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/hlg',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyDEG38WTss8JtUFIfT83Ixcv7H4hydbqBI',
      authDomain: 'hl-global.firebaseapp.com',
      databaseURL: 'https://hl-global-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'hl-global',
      storageBucket: 'hl-global.appspot.com',
      messagingSenderId: '911773256188',
      appId: '1:911773256188:web:d6407b4754394411550a79',
      measurementId: 'G-GZN8NK510N',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'kgfnb',
    VUE_APP_API_HOST: 'https://api.clp.kr/kgfnb',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/kgfnb',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyBitB0RRAO6GJuFMKcMlMlZLLNemxGbvE4',
      authDomain: 'hollys-32fea.firebaseapp.com',
      databaseURL: 'https://hollys-32fea-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'hollys-32fea',
      storageBucket: 'hollys-32fea.appspot.com',
      messagingSenderId: '376842278594',
      appId: '1:376842278594:web:39eaf78e70444736ce8d5b',
      measurementId: 'G-CPTWRDJN8P',
    },
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
    SKILL_PATH_AUTHORIZATION: [],
    IDP_SERVICE_URL: {},
    IDP_SIGNOUT_URL: '',
  },
  {
    BRAND_CODE: 'hsd',
    VUE_APP_API_HOST: 'https://api.clp.kr/hsd',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/hsd',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCyHSVtSW71xQkPkYTZB1gTToFxxTM6B2I',
      authDomain: 'sic-sft.firebaseapp.com',
      databaseURL: 'https://sic-sft-default-rtdb.firebaseio.com',
      projectId: 'sic-sft',
      storageBucket: 'sic-sft.appspot.com',
      messagingSenderId: '485712161442',
      appId: '1:485712161442:web:5679cbb73cd0d105d745fb',
      measurementId: 'G-RFJM5Y58CF',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'insg',
    VUE_APP_API_HOST: 'https://api.clp.kr/insg',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/insg',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyBaWw7WbHnhCyH5iJnrR8429L0jQVTS8cQ',
      authDomain: 'innischoolg.firebaseapp.com',
      databaseURL: 'https://innischoolg.firebaseio.com',
      projectId: 'innischoolg',
      storageBucket: 'innischoolg.appspot.com',
      messagingSenderId: '104238445251',
      appId: '1:104238445251:web:7df2cc4b2a5c994228a876',
      measurementId: 'G-EQK3M6Z5XE',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'pur',
    VUE_APP_API_HOST: 'https://api.clp.kr/pur',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/pur',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCmcfAsPLBiCkInzXURp9ImYthHvdMEcrc',
      authDomain: 'idus-korea.firebaseapp.com',
      databaseURL: 'https://idus-korea-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'idus-korea',
      storageBucket: 'idus-korea.appspot.com',
      messagingSenderId: '869288371810',
      appId: '1:869288371810:web:209e20bc2a69854182933b',
      measurementId: 'G-ZK0Z3WYRT2',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'saem',
    VUE_APP_API_HOST: 'https://api.clp.kr/saem',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/saem',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyDenuUgpuI-fCxRvcKimkbacbGtboKkVbk',
      authDomain: 'thesaem-d2395.firebaseapp.com',
      databaseURL: 'https://thesaem-d2395-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'thesaem-d2395',
      storageBucket: 'thesaem-d2395.appspot.com',
      messagingSenderId: '119235307054',
      appId: '1:119235307054:web:97aa690f5478a619bc21bf',
      measurementId: 'G-GPTX9HPZMP',
    },
    NAVER_KEY: 'B96_LvS9XEffy3bGHbcp',
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'sttc',
    VUE_APP_API_HOST: 'https://api.clp.kr/sttc',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/sttc',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyALrzxG86to2hXL0rv7_AJLlHqsnqngENA',
      authDomain: 'sttc-62ee8.firebaseapp.com',
      projectId: 'sttc-62ee8',
      storageBucket: 'sttc-62ee8.appspot.com',
      messagingSenderId: '476824454100',
      appId: '1:476824454100:web:f1840f1700c239d4c84c41',
      measurementId: 'G-VQ3HMGKM14',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    VUE_COMMON_CSS: 'sttc',
    NAVER_KEY: 'SWDXkpqiWDurpVbkP_HE',
    TELEGRAM_BOT: 'sttc_prod_bot',
    TELEGRAM_URL: 'https://t.me/sttc_prod_bot?linkType=INTERNAL_LINK',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'tke',
    VUE_APP_API_HOST: 'https://api.clp.kr/tke',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/tke',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCdQIGWkUiyWaNGtadRvVCrBqnEdCEVE0k',
      authDomain: 'tinker-education-f6d5b.firebaseapp.com',
      databaseURL: 'https://tinker-education-f6d5b.firebaseapp.com',
      projectId: 'tinker-education-f6d5b',
      storageBucket: 'tinker-education-f6d5b.appspot.com',
      messagingSenderId: '488048351871',
      appId: '1:488048351871:web:b85a4a77b06a2802ed3d4a',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'ton',
    VUE_APP_API_HOST: 'https://api.clp.kr/ton',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/ton',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyAxWbC-dhhXje6zogXEN0N8HcJ1dopAmYc',
      authDomain: 'tonyedu-7d5b0.firebaseapp.com',
      databaseURL: 'https://tonyedu-7d5b0-default-rtdb.firebaseio.com',
      projectId: 'tonyedu-7d5b0',
      storageBucket: 'tonyedu-7d5b0.appspot.com',
      messagingSenderId: '297489729427',
      appId: '1:297489729427:web:59aa995ff746cd5eb00a66',
      measurementId: 'G-KLVMSF5P5K',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'hlcn',
    VUE_APP_API_HOST: 'https://api.hallaedu.com',
    VUE_APP_PAYMENT_HOST: 'https://learner.hallaedu.com',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyDEG38WTss8JtUFIfT83Ixcv7H4hydbqBI',
      authDomain: 'hl-global.firebaseapp.com',
      databaseURL: 'https://hl-global-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'hl-global',
      storageBucket: 'hl-global.appspot.com',
      messagingSenderId: '911773256188',
      appId: '1:911773256188:web:d6407b4754394411550a79',
      measurementId: 'G-GZN8NK510N',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
      reviewBoardUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    VUE_COMMON_CSS: 'spc',
    NAVER_KEY: '',
    TELEGRAM_BOT: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'isf',
    VUE_APP_API_HOST: 'https://api.clp.kr/isf',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/isf',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyD8pfklJqFMtLT3nVZZBg1ghV0aAIaJins',
      authDomain: 'insaengfood-570e2.firebaseapp.com',
      databaseURL: 'https://insaengfood-570e2-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'insaengfood-570e2',
      storageBucket: 'insaengfood-570e2.firebasestorage.app',
      messagingSenderId: '214430797285',
      appId: '1:214430797285:web:485e67d042414b31adf30c',
      measurementId: 'G-TXWDGVJ1GN',
    },
    SKILL_PATH_AUTHORIZATION: [''],
    IDP_SERVICE_URL: {
      udemyUrl: '',
      githubUrl: '',
      judgeUrl: '',
      idpUrl: '',
    },
    IDP_SIGNOUT_URL: '',
    FAVICON_URL: 'https://emcast-clp-2.s3.ap-northeast-2.amazonaws.com/develop/favicon/favicon.ico',
  },
  {
    BRAND_CODE: 'brc',
    VUE_APP_API_HOST: 'https://api.clp.kr/brc',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/brc',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyDxLr6FNY0cbF-WbOz9jD8z8ebiB-dZzRE',
      authDomain: 'barunchicken-2b1d1.firebaseapp.com',
      databaseURL: 'https://barunchicken-2b1d1-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'barunchicken-2b1d1',
      storageBucket: 'barunchicken-2b1d1.firebasestorage.app',
      messagingSenderId: '394361402413',
      appId: '1:394361402413:web:00c1dbf69d13a5a6ebf4a4',
      measurementId: 'G-PGHGFN16RD',
    },
  },
  {
    BRAND_CODE: 'sgf',
    VUE_APP_API_HOST: 'https://api.clp.kr/sgf',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/sgf',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyBrFNTy92nigLsLWHQzsbSSH6MPRQ2NHZc',
      authDomain: 'sgfco-691a0.firebaseapp.com',
      databaseURL: 'https://sgfco-691a0-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'sgfco-691a0',
      storageBucket: 'sgfco-691a0.firebasestorage.app',
      messagingSenderId: '1020454481539',
      appId: '1:1020454481539:web:603d2628b8ec473a6235b6',
      measurementId: 'G-NYSJKQ8KHR',
    },
  },
  {
    BRAND_CODE: 'anchor-s',
    VUE_APP_API_HOST: 'https://api.clp.kr/anchor-s',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/anchor-s',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCg9NwoMrZ6Nd7pgfSg2XeWLrTX7dDNGyM',
      authDomain: 'anchor-s.firebaseapp.com',
      databaseURL: 'https://anchor-s-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'anchor-s',
      storageBucket: 'anchor-s.firebasestorage.app',
      messagingSenderId: '811983413490',
      appId: '1:811983413490:web:9db8ceb0c5a5fea0a3306b',
      measurementId: 'G-SQCBF7YWVT',
    },
  },
  {
    BRAND_CODE: 'mst',
    VUE_APP_API_HOST: 'https://api.clp.kr/mst',
    VUE_APP_PAYMENT_HOST: 'https://learner.clp.kr/mst',
    VUE_FIREBASE_INIT: {
      apiKey: 'AIzaSyCe0Z6XJtNFqQNvW5MeM78QVoZWGVX7y1A',
      authDomain: 'momstouch-ab1bb.firebaseapp.com',
      databaseURL: 'https://momstouch-ab1bb-default-rtdb.asia-southeast1.firebasedatabase.app',
      projectId: 'momstouch-ab1bb',
      storageBucket: 'momstouch-ab1bb.firebasestorage.app',
      messagingSenderId: '157713429562',
      appId: '1:157713429562:web:7914b6408c2ea53d07f103',
      measurementId: 'G-7EHPWZB4P0',
    },
  },
];

export default prodConfig;
